import timeDepositConstants from '../actiontypes/timeDeposit';

const initialState = {
  amount: '',
  timeLimit: '',
  defaultExpirationDate: '',
  expirationDate: '',
  depositType: 'R',
  step: 1,
  result: {},
  resultSelected: {},
  accountOut: '',
  accountIn: '',
  termsAccepted: false,
  newTimeDeposit: {},
  disabledDays: [],
  rating: 0,
  comment: '',
  montoLimitDap: 0
};

function simulation(state = initialState, action) {
  switch (action.type) {
    case timeDepositConstants.HOLIDAYS_SUCCESS:
      return {
        ...state,
        disabledDays: action.payload,
        timeLimit: action.timeLimit
      };
    case timeDepositConstants.HOLIDAYS_FAILURE:
      return { ...state, disabledDays: action.payload };
    case timeDepositConstants.AMOUNT_CHANGED:
      return { ...state, amount: action.payload };
    case timeDepositConstants.TIMELIMIT_CHANGED:
      return { ...state, timeLimit: action.payload };
    case timeDepositConstants.DEPOSIT_TYPE_CHANGED:
      return { ...state, depositType: action.payload };
    case timeDepositConstants.STEP_CHANGED:
      return { ...state, step: action.payload };
    case timeDepositConstants.SIMULATION_REQUEST:
      return { ...state };
    case timeDepositConstants.SIMULATION_SUCCESS:
      return { ...state, result: action.payload };
    case timeDepositConstants.SIMULATION_FAILURE:
      return { ...state, result: {} };
    case timeDepositConstants.SIMULATION_SELECTED:
      return { ...state, resultSelected: action.payload };
    case timeDepositConstants.TERMS_CHANGED:
      return { ...state, termsAccepted: action.payload };
    case timeDepositConstants.ACCOUNT_OUT_CHANGED:
      return { ...state, accountOut: action.payload };
    case timeDepositConstants.ACCOUNT_IN_CHANGED:
      return { ...state, accountIn: action.payload };
    case timeDepositConstants.SIGN_IN_REQUEST:
      return { ...state };
    case timeDepositConstants.SIGN_IN_SUCCESS:
      return { ...state, newTimeDeposit: action.payload };
    case timeDepositConstants.SIGN_IN_FAILURE:
      return { ...state, newTimeDeposit: {} };
    case timeDepositConstants.SIMULATION_CLEANED:
      return initialState;
    case timeDepositConstants.RESULT_CLEANED:
      return {
        ...state,
        accountIn: '',
        accountOut: '',
        termsAccepted: false
      };
    case timeDepositConstants.EXPIRATION_DATE_CHANGED:
      return {
        ...state,
        expirationDate: action.expirationDate,
        timeLimit: action.timeLimit
      };
    case timeDepositConstants.DEF_EXP_DATE_CHANGED:
      return {
        ...state,
        defaultExpirationDate: action.defaultExpirationDate
      };
    case timeDepositConstants.RATING_SELECTED:
      return {
        ...state,
        rating: action.payload
      };
    case timeDepositConstants.ASSESMENT_COMMENT_CHANGED:
      return {
        ...state,
        comment: action.payload
      };
    case timeDepositConstants.LOAD_CONFIG_DAP_SUCCESS:
      return {
        ...state,
        montoLimitDap: action.payload
      };

    case timeDepositConstants.LOAD_CONFIG_DAP_FAILURE:
      return {
        ...state,
        montoLimitDap: action.monto
      };

    default:
      return state;
  }
}

export default simulation;
